import React from 'react';
import { Divider as AntDivider } from 'antd';

/**
 * Wrapper component for Ant Design Divider
 * 
 * This wrapper allows us to easily replace Ant Design in the future without changing all imports.
 * It preserves all Ant Design Divider functionality including orientation, type, and dashed options.
 * 
 * @component
 * @example
 * import { Divider } from '../GeneralComponents/ui';
 * 
 * <Divider />
 * <Divider dashed />
 * <Divider type="vertical" />
 * <Divider orientation="left">Left Text</Divider>
 * <Divider orientation="right">Right Text</Divider>
 * 
 * @see https://ant.design/components/divider/ - Ant Design Divider documentation
 */
const Divider = (props) => {
  return <AntDivider {...props} />;
};

export default Divider;

